import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { client as ClientApi } from '@teem/constants/api';


@Component({
  selector: 'app-quick-payment-modal',
  templateUrl: './quick-payment-modal.component.html',
  styles: []
})
export class QuickPaymentModalComponent implements OnInit {
  clientListApi: string = ClientApi.list;
  quickPaymentForm: FormGroup;
  submitted: boolean = false;
  paymentResponse: any = null;
  onSuccess: any;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private invoiceService: InvoiceService,
    private loaderService: LoaderService) {
    // el.nativeElement.id = 'quick-payment';
  }


  ngOnInit() {
    this.quickPaymentForm = this.fb.group({
      client_id: [null, Validators.required],
      amount: [null, [Validators.required, Validators.min(0.01)]],
    })
  }

  submit() {
    this.submitted = true;

    if (this.quickPaymentForm.valid) {

      this.loaderService.startLoading();

      this.invoiceService.quickPaymentLink(this.quickPaymentForm.value).subscribe((data: any) => {
        this.loaderService.stopLoading();
        this.paymentResponse = {
          payment_link: data.payment_link
        };

        this.onSuccess();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  copyLink(inputElement?: any) {
    try {
      inputElement.select();
      (document as any).execCommand('copy');
      inputElement.setSelectionRange(0, 0);

      Swal.fire(i18n.done, i18n.invoice.payment_link_copied, 'success');
    } catch (err) {
      console.error(err);
    }
  }
}
